import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { parseResponse, type InferRequestType } from "hono/client";

import { client } from "~/lib/api";
import { meQueryKey } from "~/lib/api/me";

type EnrollRequest = InferRequestType<typeof client.portal.enroll.$post>["json"];

export const enrollCodeQueryOptions = (enrollCode: string) =>
  queryOptions({
    queryKey: ["portal", "enroll-codes", enrollCode] as const,
    queryFn: () =>
      parseResponse(
        client.portal["enroll-codes"][":code"].$get({ param: { code: enrollCode } }),
      ),
    staleTime: Infinity,
  });

export const enrollMutationOptions = () =>
  mutationOptions({
    mutationFn: (json: EnrollRequest) =>
      parseResponse(client.portal.enroll.$post({ json })),
    onSuccess: (partner, _json, _result, context) => {
      context.client.setQueryData(meQueryKey, partner);
    },
  });
